import { BaseDto } from '@/shared/dtos/base-dto';
import { ImagenProducto } from './ImagenProducto';

export class ProductoAmazon extends BaseDto {
    public titulo_producto !: string;
    public descripcion !: string;
    public precio_amazon !: number;
    public precio_venta !: number;
    public categoria !: string;
    public subcategoria !: string;
    public localizacion !: string;
    public lpn !: string;
    public peso !: string;
    public coste !: number;
    public asin !: string;
    public hiRes !: string;
    public thumb !: string;
    public large !: string;
    public estado!:number;
    public link_amazon !: string;
    public vendido !: boolean;
    public precio_venta_nogociacion !: number;
    public imagenes!:ImagenProducto[];
 } 
